// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrentCredits_container__3UyY7","title":"CurrentCredits_title__2dhTf","credits":"CurrentCredits_credits__37Vv7","number":"CurrentCredits_number__2Z8K7"};